import { useState } from "react"; // TODO: This was added for isMenuOpen Mobile Nav - CONSIDER IF WANT MOVE ELSEWHERE (diff file?)
import { useNavigate } from "react-router-dom";

import "../css/Header.css";
import logo from "./../assets/img/logo_TEMP.png";

import { toCamelCase, toKebabCase } from "../utilities/helpers";

import { MoreToCome, FeatureComingSoon, FeatureComingSoonMobile, HamburgerMenu } from "../common/Components"; // TODO: Move to where MoreToCome will go
import { Color, TextColor, BackgroundColor,
         SubjectSelector, SubjectTypeSelector, ProgramSelector, FeatureTypeSelector, DropDownTypeSelector, EngagementTypeSelector } from "@Beasted1010/pivotal-wisdom";

import { useDevice } from "../context/DeviceContext";
import { RibbonContextProvider } from "../context/RibbonContext";
import { useRibbon, useRibbonUpdate } from "../context/RibbonContext";

import { useUser } from "../context/UserContext";

import { AccountModal } from "../common/UserComponents";


export {
  Header
};



// TODO: Move to some "DropDown" Component File ???
// TODO: Name this "DropDownTypeSelector" instead? And move to Selectors section of enums.ts?


function Header( { content }: {content: any} ) {

  return (
    <header className="site-header">
      <RibbonContextProvider>
        <Ribbon />
      </RibbonContextProvider>

      {content}
    </header>
  );
}


function Ribbon() {

  return (
    <div className="site-header_ribbon">
      <Brand />

      <div className="site-header_ribbon_spacer" style={{flex: "1 1 50%", maxWidth: "150px"}} ></div>
      <Navigation />
      <div className="site-header_ribbon_spacer" style={{flex: "1 1 50%", maxWidth: "150px"}} ></div>

      <AccountHeaderButton />
      <AccountModal />
    </div>
  );
}

function Brand() {
  const navigate = useNavigate();

  return (
    <div className="site-header_brand" onClick={() => navigate("/product")} >
      <img src={logo} alt="" className="site-header_logo" />
      <div className="site-header_title">
        <h1 className="site-header_name">Pivotal Wisdom</h1>
        <h3 className="site-header_slogan">Knowledge + Experience</h3>
        {/*
        <h1 className="site-header_name">BRAND NAME</h1>
        <h3 className="site-header_slogan">BRAND SLOGAN</h3>
        */}
      </div>
    </div>
  );
}

function Navigation() {
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState( false );
  const { focusDropDown, expandMobileDropDown } = useRibbonUpdate();

                const { subjectsMetadata, focusedSubject, focusedDropDownName } = useRibbon();
                const { moreDropDownEntries, focusedMoreMenuItem } = useRibbon(); // TODO NOTE NEW FOR DROPDOWN

  const toggleNavMenu = () => setIsMenuOpen( !isMenuOpen );

  return (
    <nav className="site-header_nav">
      <div className="site-header_nav_hamburger-menu-container" onClick={toggleNavMenu} >
        {/*<div className="site-header_nav_hamburger-menu_close-button" onClick={toggleNavMenu} >X</div>*/}
        <HamburgerMenu />
      </div>

      { isMenuOpen && (
        <>
          <div className={`mobile-nav_drawer ${isMenuOpen ? "open" : ""}`} >
            <div className="" onClick={() => setIsMenuOpen(false)} >X</div>

            <a className="mobile-nav_drawer_header" onClick={() => navigate("/product")} >
              <h1 className="site-header_name">BRAND NAME</h1>
              <h3 className="site-header_slogan">BRAND SLOGAN</h3>
            </a>

            <nav className="mobile-nav_drawer_menu" >
              {/* TODO: Consider (ask ChatGPT)... Structure as <li><a>..</li> for SEO / Accessibility Best Practices (it's most Semantic) */}
              <div className="mobile-nav_drawer_menu_item">
                <button className="mobile-nav_drawer_menu_item_button" onMouseDown={() => expandMobileDropDown(DropDownTypeSelector.FOUNDATION)}>
                  Foundation
                </button>

                {
                  focusedDropDownName === DropDownTypeSelector.FOUNDATION &&
                  subjectsMetadata?.map( (subject: ISubjectMetadata, index: number) => {
                    return <Subject name={subject.name} color={subject.color} isFocused={false} key={subject.name} />
                  })
                }
              </div>
              <div className="mobile-nav_drawer_menu_item">
                <button className="mobile-nav_drawer_menu_item_button" onMouseDown={() => expandMobileDropDown(DropDownTypeSelector.COURSES)}>
                  Courses
                </button>
                
                {
                  focusedDropDownName === DropDownTypeSelector.COURSES &&
                  subjectsMetadata?.map( (subject: ISubjectMetadata, index: number) => {
                    return <Subject name={subject.name} color={subject.color} isFocused={false} key={subject.name} />
                  })
                }
              </div>
              <div className="mobile-nav_drawer_menu_item">
                <button className="mobile-nav_drawer_menu_item_button" onMouseDown={() => expandMobileDropDown(DropDownTypeSelector.COACHING)}>
                  Coaching
                </button>
                
                {
                  focusedDropDownName === DropDownTypeSelector.COACHING ? 
                  <>
                      <div className="site_header_nav_menu_item">
                        <FeatureComingSoonMobile /> 
                      </div>
                      {/*subjectsMetadata?.map( (subject: ISubjectMetadata, index: number) => {
                        <Subject name={subject.name} color={subject.color} isFocused={false} key={subject.name} />
                      })*/}
                  </>
                    : 
                      <></>

                }
              </div>
              <div className="mobile-nav_drawer_menu_item">
                <button className="mobile-nav_drawer_menu_item_button" onMouseDown={() => expandMobileDropDown(DropDownTypeSelector.MORE)}>
                  More
                </button>
                
                {
                  focusedDropDownName === DropDownTypeSelector.MORE &&
                  moreDropDownEntries.map( (entry: IMoreMenuItem) => {
                    //const isFocused = entry.name === focusedEntry?.name;
                    return <MoreMenuItem name={entry.name} color={Color.White} isFocused={false} key={entry.name} />
                  })

                  /*
                  focusedDropDownName === DropDownTypeSelector.MORE &&
                  subjectsMetadata?.map( (subject: ISubjectMetadata, index: number) => {
                    //const isFocused = subject.name === focusedSubject?.name;
                    //return <Subject name={subject.name} color={subject.color} isFocused={isFocused} key={subject.name} />

                    return <div className="">{subject.name}</div>
                  })
                  */
                }
              </div>
              <a className="mobile-nav_drawer_menu_item" href="/purchase">Purchase</a>
            </nav>
          </div>
          <div className="screen-overlay" onClick={toggleNavMenu} ></div>
        </>
      )}

      <ul className="site-header_nav_list" id="navigationMenu">
        <li onMouseEnter={() => focusDropDown(DropDownTypeSelector.FOUNDATION)}>
          Foundation
          <DropDown type={DropDownTypeSelector.FOUNDATION} />
        </li>

        <li onMouseEnter={() => focusDropDown(DropDownTypeSelector.COURSES)}>
          Courses
          <DropDown type={DropDownTypeSelector.COURSES} />
        </li>

        <li onMouseEnter={() => focusDropDown(DropDownTypeSelector.COACHING)}>
          Coaching
          <DropDown type={DropDownTypeSelector.COACHING} />
        </li>

        {/* TODO: Make a DropDown ?? Or at least own CSS class so not bold...? */}
        <li><a className="site-header_nav_purchase_link" href="/portfolio"><i><b>Credentials</b></i></a></li>

        <li onMouseEnter={() => focusDropDown(DropDownTypeSelector.MORE)}>
          More!
          <DropDown type={DropDownTypeSelector.MORE} />
        </li>

        <li><a className="site-header_nav_purchase_link" href="/purchase"><i><b>Purchase</b></i></a></li>
      </ul>
    </nav>
  );
}

function DropDown( {type}: {type: DropDownTypeSelector} ) {

  return (
    <>
      <DropDownSpacer />
      {renderDropDown( type )}
    </>
  );
}

function renderDropDown( type: DropDownTypeSelector ) {
  switch( type ) {
    case DropDownTypeSelector.FOUNDATION:
      return <FoundationNavigationDropDown />;
      break;
    case DropDownTypeSelector.COURSES:
      return <CoursesNavigationDropDown />;
      break;
    case DropDownTypeSelector.COACHING:
      return <CoachingNavigationDropDown />;
      //return <FeatureComingSoon />
      break;
    case DropDownTypeSelector.MORE:
      return <MoreNavigationDropDown />;
      break;
  }
}

function AccountHeaderButton() {

  const { user } = useUser();

  const renderUserName = () => {
    return (
      <div className="log-in_button">
        {
          user == null ?
            "Unknown User"
          :
            <>
              <img className="log-in_button_avatar" src={user.avatarURL} />
              <span>{user.name}</span>
            </>
        }
      </div>
    );
  }

  return (
    <div className="site-header_log-in_container">
      {
        user == null ?
          <button className="log-in_button"><span>Log In</span></button>
        :
          renderUserName()
      }
    </div>
  );
}




/* =========================== Navigation DropDowns =========================== */

/* =========================== FOUNDATION */
function FoundationNavigationDropDown() {
  const { subjectsMetadata, focusedSubject } = useRibbon();

  return renderSubjectsDropDown( subjectsMetadata, focusedSubject );
}



/* =========================== COURSE */
function CoursesNavigationDropDown() {
  const { subjectsMetadata, focusedSubject } = useRibbon();

  return renderSubjectsDropDown( subjectsMetadata, focusedSubject );
}


function Subject( {name, color, isFocused}: {name: string, color: Color, isFocused: boolean} ) {
  const navigate = useNavigate();

  const focusedHighlightClass = isFocused ? "site_header_nav_menu_item_highlight" : "";
  const focusedSubjectClass = isFocused ? "focused-subject" : "";

  const { focusedSubject } = useRibbon();
  const { focusSubject, focusMenuItem } = useRibbonUpdate();

  if( focusedSubject == null ) return <></>; // TODO Proper Error handle ?? Why need this? but not for focusedSubject above in CoursesNavigationDropDown???

  const goToSubject = (subjectName: string) => {
    // TODO: The looks of this makes me think it's overly complicated and can be simplified greatly
    // ... Not clear (from a future glance), why "focusSubject" is called here...
    // TODO: Verify ok. Copied/modified from goToProgram() -- Which has a LOT of TODOs

    const newFocusedSubject = focusSubject( subjectName ); // TODO: Better way? Kind of hacking together a means to update focusedSubject in order for the right Subject/Program Data to be used throughout here

    const subjectSelectorKey: string | undefined = toCamelCase( subjectName );
    const type = newFocusedSubject.type;

    if( subjectSelectorKey == null ) return; // TODO: Error Handle

    const selectedSubject = subjectSelectorKey as SubjectSelector;

    const programs = newFocusedSubject.programs;

    if( !programs || programs.length <= 0 ) return;
    const firstProgram = toCamelCase( programs[0].name );

    // TODO: Currently just blindly adding toKebabCase to get consistency with URL -- Consider more efficient way to handle this or at least place earlier to have variable itself already be in Kebab Case
    navigate( `/content/${toKebabCase(type)}/${toKebabCase(selectedSubject)}/${toKebabCase(firstProgram)}` ); // TODO: selectedFeature
  }

  return (
    <div onMouseEnter={ () => { focusMenuItem(name); } } onClick={() => goToSubject(name)} className="site_header_nav_menu_item">
      <div className={`${focusedHighlightClass} ${BackgroundColor[color]}`}></div>
      <h2 className={`site_header_nav_menu_item_name ${focusedSubjectClass}`}>{name}</h2>
    </div>
  );
}


function SubjectMenuContent( {color}: {color: Color} ) {
  // TODO: This currently is SubjectMenuContent for COURSES DROPDOWN ONLY -- add a SWITCH Statement to make dynamic and pass in which type to use??? -- Use ENUM for DropDown Types
  //          --- NOTE: renderDroPDown already has similar Switch
  const { focusedSubject } = useRibbon();
  if( focusedSubject == null ) return <></>; // TODO Proper Error handle ?? Why need this? but not for focusedSubject above in CoursesNavigationDropDown???

  return (
    <div className={`site_header_nav_menu_item_content ${BackgroundColor[color]}`}>
      {
        focusedSubject.programs.map( (program: IProgramMetadata, index: number) => {
          // TODO TODO TODO - may not always be "Program", i.e. Coaching DropDown may not have -- SWITCH ? See above TODOs
          return <SubjectMenuContentEntry subjectType={focusedSubject.type} program={program} key={program.name} />
        })
      }
    </div>
  );
}

function SubjectMenuContentEntry( {subjectType, program}: {subjectType: SubjectTypeSelector, program: IProgram}) {
  const navigate = useNavigate();

  const { focusedSubject } = useRibbon();
  if( focusedSubject == null ) return <></>; // TODO Proper Error handle ?? Why need this? but not for focusedSubject above in CoursesNavigationDropDown???

  const goToProgram = ( event: React.MouseEvent<HTMLDivElement, MouseEvent> ) => {
    event.stopPropagation();

    const selectedSubject = program.subjectSelector;
    const selectedProgram = program.selector;

    // TODO: What if not exist on this particular Program ????
    //    --  Have Default Property on Program Feature JSON ??
    // Default to Course as first Feature
    // TODO: This assumes all Programs have a Course Feature
    //       Should always be the case, but add check to ensure not break
    //       CONSIDER "Default Feature" on Program JSON and use here
    const selectedFeature = FeatureTypeSelector.COURSE;

    // TODO: Currently just blindly adding toKebabCase to get consistency with URL -- Consider more efficient way to handle this or at least place earlier to have variable itself already be in Kebab Case
    navigate( `/content/${toKebabCase(subjectType)}/${toKebabCase(selectedSubject)}/${toKebabCase(selectedProgram)}/${toKebabCase(selectedFeature)}` ); // TODO: selectedFeature
  }

  return (
    <div onClick={goToProgram}className="site_header_nav_menu_item_content_entry">
      <h2 className="site_header_nav_menu_item_content_entry_name">{program.name}</h2>
      {/* TODO: Prop Drilling programName (and subjectType). ALSO, calling "name" in multiple Components (here and in FeatureIconPopUpFeature()), but maybe better call it as it is, "programName"?? */}
      <FeatureIcon subjectType={subjectType} features={program.features} programName={program.name} />
    </div>
  );
}

function FeatureIcon( {subjectType, features, programName}: {subjectType: string, features: IFeatureMetadata[], programName: string}) {
  return (
    <div className="site_header_nav_menu_item_content_entry_related-content_icon">&#9733;
      <DropDownSpacer />
      <FeatureIconPopUp subjectType={subjectType} features={features} programName={programName} />
    </div>
  );
}

function FeatureIconPopUp( {subjectType, features, programName}: {subjectType: string, features: IFeatureMetadata[], programName: string}) {

  return (
    <div className="site_header_nav_menu_item_content_entry_related-content_popup" >
      {
        features.map( (feature: IFeatureMetadata, index: number) => {
          // TODO TODO TODO - may not always be "Program", i.e. Coaching DropDown may not have -- SWITCH ? See above TODOs
          return <FeatureIconPopUpFeature name={feature.type} featureSelector={feature.selector} programSelector={feature.programSelector} subjectSelector={feature.subjectSelector} subjectType={subjectType} key={feature.type} />
        })
      }
      <MoreToCome />
    </div>
  );
}

function FeatureIconPopUpFeature( {subjectType, name, featureSelector, programSelector, subjectSelector}: any ) {
  const navigate = useNavigate();

  const goToFeature = ( event: React.MouseEvent<HTMLDivElement, MouseEvent> ) => {
    event.stopPropagation();

    const featureUrlPath = `/content/${toKebabCase(subjectType)}/${toKebabCase(subjectSelector)}/${toKebabCase(programSelector)}/${toKebabCase(featureSelector)}`;

    navigate( featureUrlPath );
  }

  return (
    <div className="site_header_nav_menu_item_content_entry_related-content_popup_feature" onClick={goToFeature} >
      {name}
    </div>
  );
}



/* =========================== COACHING */
function CoachingNavigationDropDown() {
  const { coachingEngagements, focusedCoachingEngagement } = useRibbon();

  return renderCoachingDropDown( coachingEngagements, focusedCoachingEngagement );
}


///////////////////////// TODO: BELOW WAS HACKED FROM MORE MENU #####################################
function CoachingEngagement( {name, color, isFocused}: {name: string, color: Color, isFocused: boolean} ) {
  const navigate = useNavigate();

  const { focusedCoachingEngagement } = useRibbon();
  const { focusMenuItem } = useRibbonUpdate();

  if( focusedCoachingEngagement == null ) {
    return <></>; // TODO: ERROR HANLDING
  }

  const engagementSelector = focusedCoachingEngagement.selector;

  const focusedHighlightClass = isFocused ? "site_header_nav_menu_item_highlight" : "";
  const focusedSubjectClass = ""; //isFocused ? "focused-subject" : "";

  const getContrastColor = ( color: Color ) => { // TODO: Make Helper in some helper or common file?
    
    switch( color ) {
      case Color.White: {
        return Color.Black;
      }

      case Color.Black: {
        return Color.White;
      }

      default: {
        console.error( `Contrast for color of ${color} isn't supported. Defaulting to Black` );
        return Color.Black;
      }
    }
  }

  //const goToCoachingEngagement = (engagementToGoTo: string) => {
  const goToCoachingEngagement = ( event: React.MouseEvent<HTMLDivElement, MouseEvent> ) => {
    //event.stopPropagation();

    const engagementToGoTo = engagementSelector;
    const firstEngagementOption = focusedCoachingEngagement.options[0];

    if( firstEngagementOption == null ) {
      return; // TODO: PROPER ERROR HANDLING...
    }

    // TODO: Currently just blindly adding toKebabCase to get consistency with URL -- Consider more efficient way to handle this or at least place earlier to have variable itself already be in Kebab Case
    navigate( `/content/coaching/${toKebabCase(engagementToGoTo)}/${toKebabCase(firstEngagementOption.selector)}` );
  }

  // TODO: For Coaching DropDown, maybe have Contrast Color be with Brand Color? I.e. var(--brand-color) and --brand-color-contrast
  const textColorClass = isFocused ? TextColor[getContrastColor(color)] : TextColor[color];
  const backgroundColorClass = isFocused ? BackgroundColor[color] : BackgroundColor[getContrastColor(color)];

  return (
    <div onClick={goToCoachingEngagement} onMouseEnter={ () => focusMenuItem(name) } className="site_header_nav_menu_item">
      <div className={`${focusedHighlightClass} ${backgroundColorClass}`}></div>
      <h2 className={`site_header_nav_menu_item_name ${focusedSubjectClass} ${textColorClass}`}>
        {name}
      </h2>
    </div>
  );
}
function CoachingEngagementMenuContent( {color}: {color: Color} ) {
  const { focusedCoachingEngagement: focusedEntry } = useRibbon();
  if( focusedEntry == null ) return <></>; // TODO Proper Error handle ?? Why need this? but not for focusedSubject above in CoursesNavigationDropDown???

  if( !focusedEntry.options || focusedEntry.options.length == 0 ) {
    return (
      <div className={`site_header_nav_menu_item_content ${BackgroundColor[color]}`}>
        <FeatureComingSoon />
      </div>
    );
  }

  return (
    <div className={`site_header_nav_menu_item_content ${BackgroundColor[color]}`}>
      {
        focusedEntry.options.map( (item: IEngagementOption, index: number) => {
          // TODO TODO TODO - may not always be "Program", i.e. Coaching DropDown may not have -- SWITCH ? See above TODOs
          return <CoachingEngagementMenuContentEntry name={item.name} optionSelector={item.selector} key={index} />
        })
      }
    </div>
  );
}
// TODO: Not MenuItem but MenuContentEntry, similar to Subject?
function CoachingEngagementMenuContentEntry( {name, optionSelector}: {name: string, optionSelector: string} ) {
  const navigate = useNavigate();

  const { focusedCoachingEngagement } = useRibbon();
  const engagementSelector = focusedCoachingEngagement.selector;

  const goToCoachingEngagement = (engagementToGoTo: EngagementTypeSelector) => {
    // TODO: Currently just blindly adding toKebabCase to get consistency with URL -- Consider more efficient way to handle this or at least place earlier to have variable itself already be in Kebab Case
    navigate( `/content/coaching/${toKebabCase(engagementToGoTo)}/${toKebabCase(optionSelector)}` ); // TODO: selectedFeature
  }

  return (
    <div onClick={() => goToCoachingEngagement(engagementSelector) } className="site_header_nav_menu_item_content_entry">
      <h2 title={name} className="site_header_nav_menu_item_content_entry_name">{name}</h2>
      {/*  TODO: Have links to specific Posts or something from this Icon? Or Videos, or Social things or Products? Not really "Features" any more given now just More Entry Items' additional thingies... So Create new with better name?
      <FeatureIcon features={[]} />
      */}
    </div>
  );
}
///////////////////////// TODO: ABOVE WAS HACKED FROM MORE MENU ######################################



/* =========================== MORE */
function MoreNavigationDropDown() {
  const { moreDropDownEntries, focusedMoreMenuItem } = useRibbon();

  return renderMoreDropDown( moreDropDownEntries, focusedMoreMenuItem );
}

// TODO: Move? Whole file may need ReFactored. Doesn't seem all that organized or well named
function MoreMenuItem( {name, color, isFocused}: {name: string, color: Color, isFocused: boolean} ) {
  const focusedHighlightClass = isFocused ? "site_header_nav_menu_item_highlight" : "";
  const focusedSubjectClass = ""; //isFocused ? "focused-subject" : "";

  const getContrastColor = ( color: Color ) => {
    
    switch( color ) {
      case Color.White: {
        return Color.Black;
      }

      case Color.Black: {
        return Color.White;
      }

      default: {
        console.error( `Contrast for color of ${color} isn't supported. Defaulting to Black` );
        return Color.Black;
      }
    }
  }

  //const textColorClass = isFocused ? TextColor[Color.White] : TextColor[Color.Black];
  //const backgroundColorClass = isFocused ? BackgroundColor[Color.Black] : BackgroundColor[Color.White];
  const textColorClass = isFocused ? TextColor[getContrastColor(color)] : TextColor[color];
  const backgroundColorClass = isFocused ? BackgroundColor[color] : BackgroundColor[getContrastColor(color)];

  const { focusMenuItem } = useRibbonUpdate();

  return (
    <div onMouseEnter={ () => { focusMenuItem(name); } } className="site_header_nav_menu_item">
      <div className={`${focusedHighlightClass} ${backgroundColorClass}`}></div>
      <h2 className={`site_header_nav_menu_item_name ${focusedSubjectClass} ${textColorClass}`}>
        {name}
      </h2>
    </div>
  );
}

function MoreMenuItemContent( {color}: {color: Color} ) {
  const { focusedMoreMenuItem: focusedEntry } = useRibbon();
  if( focusedEntry == null ) return <></>; // TODO Proper Error handle ?? Why need this? but not for focusedSubject above in CoursesNavigationDropDown???

  return (
    <div className={`site_header_nav_menu_item_content ${BackgroundColor[color]}`}>
      {
        focusedEntry.items.map( (item: IMoreMenuItemContent) => {
          // TODO TODO TODO - may not always be "Program", i.e. Coaching DropDown may not have -- SWITCH ? See above TODOs
          return <MoreMenuItemContentEntry name={item.name} link={item.link} key={item.name} />
        })
      }
    </div>
  );
}

function MoreMenuItemContentEntry( {name, link}: {name: string, link: string} ) {

  return (
    <div onClick={() => window.open(link, "_blank") } className="site_header_nav_menu_item_content_entry">
      <h2 title={name} className="site_header_nav_menu_item_content_entry_name">{name}</h2>
      {/*  TODO: Have links to specific Posts or something from this Icon? Or Videos, or Social things or Products? Not really "Features" any more given now just More Entry Items' additional thingies... So Create new with better name?
      <FeatureIcon features={[]} />
      */}
    </div>
  );
}





/* =========================== HELPERS =========================== */
// TODO: Move the Components to some "General" Components file ??

function DropDownSpacer() {

  return (
    <div className="drop-down_spacer">
    </div>
  );
}

function renderSubjectsDropDown( subjectsMetadata: ISubjectMetadata[], focusedSubject: ISubjectMetadata ) {
  // TODO Proper Error handle ?? Why need this? but not for focusedSubject???
  if( subjectsMetadata == null ) return <></>;

  return (
    <div className="site_header_nav_dropdown">

      {
        subjectsMetadata.length > 0 ?
          subjectsMetadata.map( (subject: ISubjectMetadata, index: number) => {
            const isFocused = subject.name === focusedSubject?.name;
            return <Subject name={subject.name} color={subject.color} isFocused={isFocused} key={subject.name} />
          })
        :
          <FeatureComingSoon />
      }
      <MoreToCome />

      {
        focusedSubject ?
          <SubjectMenuContent color={focusedSubject.color} />
        :
          <></>
      }
    </div>
  );
}

function renderCoachingDropDown( coachingEngagements: IEngagement[], focusedEntry: IEngagement ) {
  if( coachingEngagements == null ) return <></>; // TODO: Better Error Handle?

  return (
    <div className="site_header_nav_dropdown">

      {
        coachingEngagements.map( (engagement: IEngagement) => {
          const isFocused = engagement.name === focusedEntry?.name;
          return <CoachingEngagement name={engagement.name} color={Color.Black} isFocused={isFocused} key={engagement.name} />
        })
      }
      <MoreToCome />


      <CoachingEngagementMenuContent color={Color.Black} />
    </div>
  );
}

function renderMoreDropDown( moreDropDownEntries: IMoreMenuItem[], focusedEntry: IMoreMenuItem ) {
  if( moreDropDownEntries == null ) return <></>; // TODO: Better Error Handle?

  return (
    <div className="site_header_nav_dropdown">

      {
        moreDropDownEntries.map( (entry: IMoreMenuItem) => {
          const isFocused = entry.name === focusedEntry?.name;
          return <MoreMenuItem name={entry.name} color={Color.Black} isFocused={isFocused} key={entry.name} />
        })
      }
      <MoreToCome />


      <MoreMenuItemContent color={Color.Black} />
    </div>
  );
}





/* */
